import React from 'react';
import PropTypes from 'prop-types';
//assets
import NoDataImage from '../../assets/no-data.svg';
import NoDataGrayImage from '../../assets/no-data-gray.svg';

// Styles
import './styles.scss';

export default function NoData(props) {
  return (
    <div className="no-data-wrapper">
      {props.imageGray ? (
        <img src={NoDataGrayImage} className="no-data-image" />
      ) : (
        <img src={NoDataImage} className="no-data-image" />
      )}
      <div
        className="no-data-text"
        dangerouslySetInnerHTML={{ __html: props.message }}
      ></div>
    </div>
  );
}
NoData.propTypes = {
  message: PropTypes.string,
  imageGray: PropTypes.bool
};

NoData.defaultProps = {
  imageGray: true
};
